'use client'
import { DynamicError } from './DynamicError.js';

class MfaInvalidOtpError extends DynamicError {
    constructor() {
        super('Invalid code');
    }
}

export { MfaInvalidOtpError };
